import {
  SHOW_ADD_CLUSTER_FORM,
  CLOSE_ADD_CLUSTERS_FORM,
  UPDATE_CLUSTER_SUCCEEDED,
  UPDATE_CLUSTER_FIELD,
  REQUEST_CLUSTERS,
  RECEIVED_CLUSTERS,
  ON_BUILDING_SELECT,
  DELETE_CLUSTER_SUCCEEDED
} from '../actions/clusters'

const clustersReducer = (state = {close: false }, action) => {
  switch (action.type) {
    case CLOSE_ADD_CLUSTERS_FORM:
      return {
        ...state,
        close: false,
        cluster: null
      }

    case UPDATE_CLUSTER_FIELD:
      return {
        ...state,
        cluster: { ...state.cluster, [action.name]: action.value }
      }

    case UPDATE_CLUSTER_SUCCEEDED:
      let newClusters = state.clusters.filter((cluster) => {
        return cluster._id !== action.cluster._id
      })

      newClusters.push(action.cluster)

      return {
        ...state,
        cluster: null,
        clusters: newClusters
      }

    case REQUEST_CLUSTERS:
      return {
        ...state,
        isFetching: true
      }

    case RECEIVED_CLUSTERS:
      return {
        ...state,
        isFetching: false,
        clustersFetched: true,
        clusters: action.json
      }

    case ON_BUILDING_SELECT:
      let selectedBuildings = state.cluster.buildings

      let buildingIndex = selectedBuildings.indexOf(action.buildingId)

      if (buildingIndex == -1) {
        selectedBuildings.push(action.buildingId)
      } else {
        selectedBuildings.splice(buildingIndex, 1)
      }

      return {
        ...state,
        cluster: {
          ...state.cluster,
          buildings: selectedBuildings
        }
      }

    case SHOW_ADD_CLUSTER_FORM:
      return {
        ...state,
        cluster: action.cluster,
        close: true
      }

    case DELETE_CLUSTER_SUCCEEDED:
      return {
        ...state,
        cluster: null,
        clusters: state.clusters.filter((cluster) => {
          return cluster._id !== action.cluster._id
        })
      }

    default:
      return {
        ...state
      }
  }
}

export default clustersReducer



// WEBPACK FOOTER //
// ./src/reducers/clusters.js